import Vue from 'vue'
import VueRouter from 'vue-router'

import Review from '../views/Review.vue'
import Finish from '../views/Finish.vue'
import Errors from '../views/Error.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Review',
    component: Review
  },
  {
    path: '/finish',
    name: 'Finish',
    component: Finish
  },
  {
    path: '/err',
    name: 'Error',
    component: Errors
  }
]

const router = new VueRouter({
  routes
})

export default router
